import React, { Suspense } from 'react';
import PlatformHooker from '@beefco/sdk-ext/hooker';
/**
 * PlatformHooker с загружаемым по запросу бандлом (при рендеринге)
 */
var LazyPlatformHooker = /*#__PURE__*/React.lazy(function () {
  return import('@beefco/sdk-ext/hooker');
});
var AsyncPlatformHooker = function AsyncPlatformHooker(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazyPlatformHooker, props));
};
export var ConditionalPlatformHooker = import.meta.webpackHot && PlatformHooker || typeof window !== 'undefined' && AsyncPlatformHooker || function () {
  return null;
};